export default class LottoOdd {
    // hint: more properties exists but not important for now
    order: number;
    value: number;
    // todo: possible enum
    status: string;
    eventId: number;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/models/lotto/LottoOdd.ts